import { render, staticRenderFns } from "./BaseCopyQrCode.vue?vue&type=template&id=066b1416&scoped=true&"
import script from "./BaseCopyQrCode.vue?vue&type=script&lang=js&"
export * from "./BaseCopyQrCode.vue?vue&type=script&lang=js&"
import style0 from "./BaseCopyQrCode.vue?vue&type=style&index=0&id=066b1416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066b1416",
  null
  
)

export default component.exports